module.exports = __webpack_public_path__ + "img/project-4.5de4395a.png";